import { render } from "./HeaderUnidade.vue?vue&type=template&id=5080c50b"
import script from "./HeaderUnidade.vue?vue&type=script&lang=js"
export * from "./HeaderUnidade.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__